import { useState } from "react";
import { PrivacyPolicySheet } from "./PrivacyPolicySheet";

export const PrivacyPolicyLink = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="link link-hover text-center text-gray-400 text-xs"
            >
                Privacy policy
            </button>

            <PrivacyPolicySheet open={open} onClose={() => setOpen(false)} />
        </>
    );
};
